import { Helmet } from 'react-helmet';
import { parse } from 'query-string';

export const isInBrowser = typeof window !== 'undefined';

export function getPath() {
  if (typeof window !== 'undefined') {
    return window.location.pathname;
  }
  return '';
}

export const getTitleAndDesc = () => {
  // @ts-ignore
  const desc: string = Helmet.peek().metaTags.find((v: any) => v.name === 'description').content;

  return [document.location.href, document.title, desc];
};

export const getQueryParam = (key: string) => {
  return parse(window.location.search)[key];
};
